// services/NotificationService.ts
import { axiosService } from "@services/AxiosService";

export interface Notification {
  id: number;
  object_type: string;
  object_id: string;
  project_id: string;
  created_at: string;
  message: string;
  is_read: boolean;
  unread?: boolean;
  notification_type: string;
}

class NotificationService {
  static async fetchNotifications(
    page = 1,
    limit = 20,
    unreadOnly = false
  ): Promise<Notification[]> {
    const params: any = { page, limit };
    if (unreadOnly) params.unread_only = true;

    const response = await axiosService.get("/notifications", { params });

    return response.data.map((n: Notification) => ({
      ...n,
      unread: !n.is_read,
    }));
  }

  static async markAsRead(id: number): Promise<void> {
    await axiosService.post(`/notifications/${id}/read`);
  }

  static async markAllAsRead(): Promise<void> {
    await axiosService.put(`/notifications/read-all`);
  }
}

export default NotificationService;
